<template>
  <section class="relative">
    <button
      @click="toggleDropdown"
      :class="showDropdown ? 'z-50' : 'z-10'"
      class="block h-max relative"
    >
      <img src="../../assets/horizontal-menu.svg" alt="menu" class="w-5 h-5" />
    </button>

    <section
      ref="dropDownEl"
      :class="showDropdown ? 'opacity-1 dropdown-open z-50' : 'opacity-0 z-10'"
      class="absolute payment-dropdown top-[115%] w-[280px] border h-max flex flex-col  overflow-hidden transition-all duration-300 ease-in-out h-max"
    >
      <div class="p-1  dropdown-item">
        <button
          class="flex items-center gap-2 p-3 px-4  text-secondary-300 font-[400]"
        >
          Add to Swag Store
        </button>
      </div>
      <div class="p-1  dropdown-item">
        <button
          class="flex items-center gap-2 p-3 px-4 pb-5  text-secondary-300 font-[400]"
        >
          Add to E-commerce
        </button>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'PaymentMethodDropdown',
  data() {
    return {
      showDropdown: false,
      trigger: null,
      dropDownEl: null
    }
  },
  created() {
    document.addEventListener('click', this.onShowDropdown)
    document.addEventListener('keydown', this.onShowDropdown)
  },
  methods: {
    toggleDropdown() {
      console.log('toggleDropdown')
      this.showDropdown = !this.showDropdown
    },
    onShowDropdown() {
      //   this.showDropdown = true
    },
    hideDropdown() {
      this.showDropdown = false
    },
    clickHandler(event) {
      if (!this.dropDownEl || !this.trigger) return
      if (
        !this.showDropdown ||
        this.dropDownEl.contains(event.target) ||
        this.trigger.contains(event.target)
      )
        return
      this.showDropdown = false
    },
    keyHandler(event) {
      if (!this.showDropdown || event.keyCode !== 27) return
      this.showDropdown = false
    }
  }
}
</script>

<style scoped>
.dropdown-open {
  opacity: 1;
  height: 100px;
}

.dropdown-close {
  opacity: 0;
}

.payment-dropdown {
  top: 135%;
  right: 0rem;
  width: 200px;
  border: 1px solid #232220;
  background-color: #f5f2ee;
  .dropdown-item {
    button {
      font-size: 12px;
    }
    &:hover {
      background-color: #dfdad280;
    }
  }
}
</style>
